import React, { useEffect, useState } from 'react';
import SensorCard from './SensorCard';
import LoadingComponent from '../loading/LoadingComponent';
import { useNavigate } from 'react-router-dom';
// import { SENSORS_LOADING_MESSAGE } from '../utils/Constants';

import { sensorsList } from '../../services/sensors/sensorsService';

import { decodeToken } from '../utils/decodeToken/decodeToken';

const SensorsView = () => {
    const [sensors, setSensors] = useState([]);
    const [isFetched, setIsFetched] = useState(false);
    const [isError, setIsError] = useState(false);
    const [showSensors, setShowSensors] = useState(false);

    const backgroundImage = "url('/assets/images/backgrounds/Sensors.jpg')";

    // const [currentSensorName, setCurrentSensorName] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const token = decodeToken(localStorage.getItem('user-jwt'));        // token.sub es el correo, el email
            if (token && token.sub) {
                setTimeout(() => setShowSensors(true), 1500);
                try {
                    const response = await sensorsList();
                    setSensors(response);
                    setIsFetched(true);
                } catch (error) {
                    setIsFetched(false);
                    setIsError(true);
                    localStorage.clear();
                    navigate('/');
                }
            } else {
                navigate('/error');
            }
        };
        fetchData();
    }, [navigate]);

    // const loadingProps = {
    //     message: SENSORS_LOADING_MESSAGE,
    //     type: 'primary',
    // };

    if (isFetched && !isError && showSensors) {
        return (
            <div className="min-h-full flex flex-col">
                <div className="flex-1 min-h-screen bg-cover bg-center bg-fixed" style={{ backgroundImage: backgroundImage }}>
                    <div className='p-4 flex flex-wrap items-start justify-center gap-4'>
                        {sensors.map((sensor, index) => (
                            <SensorCard key={index}
                                // setSensorNameFunction={setCurrentSensorName} 
                                handleShow={null} // asumiendo que 'handleShow' se pasa como prop si es necesario
                                values={sensor} 
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <LoadingComponent />
                {/* <LoadingComponent data={loadingProps} /> */}
            </div>
        );
    }
};

export default SensorsView;